var _path, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 32,
    viewBox: "0 0 38 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.59859 10.6338V3C7.59859 1.89543 8.49402 1 9.59859 1H31.5C34.2614 1 36.5 3.23858 36.5 6V28.9155C36.5 30.0201 35.6046 30.9155 34.5 30.9155H9.59859C8.49402 30.9155 7.59859 30.0201 7.59859 28.9155V21.2817",
    stroke: "black",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 14.6901,
    width: 26.3662,
    height: 2.02817,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.8185,
    y: 8.68304,
    width: 9.95983,
    height: 1.48087,
    transform: "rotate(45 20.8185 8.68304)",
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 9.93529,
    height: 1.48087,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 26.814 14.6506)",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.be29d52a855154409485ec68e3a5e32f.svg";
export { ForwardRef as ReactComponent };